import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Style.scss";
import SideNav from "./TopSideNav";
import algoquantLogo from "../../Assets/Images/algoquant_logo.jpg";

// var prevScrollpos = window.pageYOffset;
// window.onscroll = function () {
//   var currentScrollPos = window.pageYOffset;
//   if (prevScrollpos > currentScrollPos) {
//     document.getElementById("navbar").style.top = "0";
//   } else {
//     document.getElementById("navbar").style.top = "-120px";
//   }
//   prevScrollpos = currentScrollPos;
// };

const NavBar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  return (
    <>
      <nav
        className="navbar sticky-top navbar-expand-lg custom-navbar"
        id="navbar"
      >
        <div className="container toggle_icon">
          <Link className="navbar-brand" to="/">
            <img
              className="brand"
              src={algoquantLogo}
              alt="Algoquant Global"
              title="Algoquant Global"
            />
          </Link>
          <SideNav />
          <div
            className={`${isNavCollapsed ? "collapse" : ""}
                            navbar-collapse justify-content-end miniLaptopNav`}
            id=""
          >
            <ul className="navbar-nav justify-content-end mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/" className="nav-link" title="about">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link" title="contact">
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <a
                  href="http://rms.algoquant.global:8888/WEBR"
                  className="nav-link primaryColor"
                  title="risk management system"
                >
                  RMS
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="http://ipo.algoquant.global:7000/"
                  className="nav-link primaryColor"
                  title="initial public offerings"
                >
                  IPO
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://122.160.40.174:10443/"
                  className="nav-link primaryColor"
                >
                  Backoffice
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  href="http://oats.algoquant.global:3000/#/app"
                  className="nav-link primaryColor"
                >
                  OATS
                </a>
              </li> */}
              <li className="nav-item">
                <Link to="/download" className="nav-link primaryColor">
                  Downloads
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
